import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { DELETE_TOOLTIP } from "../../translations";
import type { DeleteCellPropsType } from "../types";

import { StyledDeleteWrapper } from "./styles";

export const DeleteCell = ({ setting, handleDelete }: DeleteCellPropsType) => {
    const onClick = () => handleDelete(setting);

    return (
        <PlainTooltip tooltipContent={translate(DELETE_TOOLTIP)}>
            <StyledDeleteWrapper>
                <IconButton
                    type="flat"
                    iconSize="sm"
                    iconName="delete"
                    onClick={onClick}
                />
            </StyledDeleteWrapper>
        </PlainTooltip>
    );
};
